import React, { useState, useEffect, useContext } from 'react';
import MenuBar from '../components/Menubar';
import User from '../components/Utils';
import LoaderContext from '../components/LoaderContext';
import LoginPage from './LoginPage';
import ItemNew from '../components/ItemNew';

type Props = {
  user: User;
  handleLogin(user: User): void;
};

// craving update: fixed base URL to match backend
const CRAVINGS_API = () => `${process.env.REACT_APP_SERVER_URL}/cravings`;
const CravingsPage: React.FC<Props> = (props) => {
  const [cravedItems, setCravedItems] = useState<any[]>([]);
  const [error, setError] = useState('');
  const { showLoader, hideLoader } = useContext(LoaderContext);

  useEffect(() => {
    if (props.user.isLogged) {
      loadCravedItems();
    } else {
      setCravedItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user.isLogged, props.user.token]);

  const loadCravedItems = async () => {
    showLoader();
    setError('');
    try {
     // craving update: fixed endpoint name to match backend
     const res = await fetch(`${CRAVINGS_API()}/items`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${props.user.token}`,
        },
      });
      if (!res.ok) throw new Error('Failed to load cravings');
      const data = await res.json();
      setCravedItems(Array.isArray(data) ? data : []);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('Failed to load cravings');
      }
      setCravedItems([]);
    } finally {
      hideLoader();
    }
  };

  const handleLoginClick = () => {
    props.handleLogin(props.user);
  };

  const handleToggleCraving = (itemId: number) => {
    showLoader();
   // craving update: fixed endpoint name and body to match backend
   fetch(`${CRAVINGS_API()}/toggle`, {
       method: 'POST',
       headers: {
           'Content-Type': 'application/json',
           Accept: 'application/json',
           Authorization: `Bearer ${props.user.token}`,
       },
       body: JSON.stringify({ itemId }),
   })
      .then(() => {
        setCravedItems(prev => prev.filter(i => i.id !== itemId));
        hideLoader();
      })
      .catch(() => hideLoader());
  };

 // craving update: update local state after upvote so count changes without refresh
 const handleUpvote = (id: number) => {
     showLoader();
     fetch(`${process.env.REACT_APP_SERVER_URL}/items/${id}/upvote`, {
         method: 'POST',
         headers: new Headers({
             'Content-Type': 'application/json',
             Accept: 'application/json',
             Authorization: 'Bearer ' + props.user.token,
         }),
         body: JSON.stringify({ userId: props.user.id }),
     })
         .then(r => r.json())
         .then(
             () => {
                 setCravedItems(prev =>
                     prev.map(i =>
                         i.id === id
                         ? { ...i, upvoted: true, canUpvote: false, upvoteCount: i.upvoteCount + 1 }
                             : i
                     )
                 );
                 hideLoader();
             },
             () => hideLoader(),
         );
 };
// craving update: update local state after remove upvote so count changes without refresh
const handleRemoveUpvote = (id: number) => {
    showLoader();
    fetch(`${process.env.REACT_APP_SERVER_URL}/items/${id}/removeUpvote`, {
        method: 'DELETE',
        headers: new Headers({
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + props.user.token,
        }),
        body: JSON.stringify({ userId: props.user.id }),
    })
        .then(r => r.json())
        .then(
            () => {
                setCravedItems(prev =>
                    prev.map(i =>
                        i.id === id
                ? { ...i, upvoted: false, canUpvote: true, upvoteCount: Math.max(0, i.upvoteCount - 1) }
                            : i
                    )
                );
                hideLoader();
            },
            () => hideLoader(),
        );
};

const syncUpvoteCount = (id: number, upvoteCount: number) => {
    setCravedItems(prev =>
        prev.map(i =>
            i.id === id ? { ...i, upvoteCount } : i
        )
    );
};

  if (!props.user.isLogged) {
    return (
      <LoginPage
        user={props.user}
        handleLogin={props.handleLogin}
        showBack={true}
        showHome={true}
        backgroundImage={true}
        handleBack={() => {}}
      />
    );
  }

  return (
    <main className="main-bg eat-bg">
      <div className="container">
        <MenuBar user={props.user} />
      </div>

      <div className="eat-main notification-settings" style={{ marginBottom: '90px' }}>
        <h1 className="text-center pt-3 pb-2 uppercase">Cravings</h1>

        {error ? (
          <p className="text-center" style={{ color: '#e53935' }}>
            {error}
          </p>
        ) : cravedItems.length === 0 ? (
          <p className="text-center">
            No cravings yet. Heart a Yolo to add it here!
          </p>
        ) : (
          <div className="categoryItem card-container">
            {cravedItems.map(item => (
              <div key={item.id} className="categoryItemWidth">
                <ItemNew
                  handleLogin={handleLoginClick}
                  item={item}
                  editable={props.user.id == 6 || props.user.id == 7 || props.user.id == 514}
                  isLogged={props.user.isLogged}
                  user={props.user}
                  page="cravingsPage"
                  showRestaurant={true}
                  handleUpvote={handleUpvote}
                  handleRemoveUpvote={handleRemoveUpvote}
                  handleNotificationClick={() => {}}
                  restaurentPage={false}
                  loadData={loadCravedItems}
                  syncUpvoteCount={syncUpvoteCount}
                  handleMainFilter={() => {}}
                  craved={true}
                  handleToggleCraving={handleToggleCraving}
                />
              </div>
            ))}
          </div>
        )}
      </div>


    </main>
  );
};

export default CravingsPage;
